// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressTracker[data-v-5efbda5e] {
  display: flex;
  flex-flow: row nowrap;
  margin: 15px auto;
}
.progressTracker .step[data-v-5efbda5e] {
  flex: 1 0 100px;
  height: 75px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: #8B8B8B;
  position: relative;
  display: inline-block;
}
.progressTracker .step .checkContainer[data-v-5efbda5e] {
  display: inline-block;
  height: 25px;
  font-size: 16px;
  color: var(--default-color);
  width: 100%;
}
.progressTracker .step .checkContainer .fa[data-v-5efbda5e] {
  visibility: hidden;
}
.progressTracker .step .checkContainer .fa.completed[data-v-5efbda5e] {
  visibility: visible;
}
.progressTracker .step .bar[data-v-5efbda5e] {
  display: inline-block;
  background-color: var(--default-color);
  opacity: 0.25;
  height: 6px;
  width: 100%;
  margin-top: 6px;
}
.progressTracker .step .bar.completion[data-v-5efbda5e] {
  position: absolute;
  top: 26px;
  left: 0px;
  opacity: 1;
  z-index: 3;
  width: 0px;
}
.progressTracker .step .stepName[data-v-5efbda5e] {
  margin: 8px 11px;
  height: 24px;
  display: inline-block;
  line-height: 12px;
  color: inherit;
}
.progressTracker .step a.stepName[data-v-5efbda5e]:hover {
  color: var(--default-color);
}
.progressTracker .step.active[data-v-5efbda5e] {
  color: var(--text-color);
}
.progressTracker .step.completed[data-v-5efbda5e] {
  color: var(--text-color);
}
.progressTracker .step:first-of-type .bar[data-v-5efbda5e] {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}
.progressTracker .step:last-of-type .bar[data-v-5efbda5e] {
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/progressTracker/src/progressTracker.vue","webpack://./progressTracker.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;ACAF;ADCE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;ACCJ;ADAI;EACE,qBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;ACEN;ADDM;EACE,kBAAA;ACGR;ADDM;EACE,mBAAA;ACGR;ADAI;EACE,qBAAA;EACA,sCAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;ACEN;ADAI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;ACEN;ADAI;EACE,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;ACEN;ADCI;EACE,2BAAA;ACCN;ADEI;EACE,wBAAA;ACAN;ADEI;EACE,wBAAA;ACAN;ADII;EACE,4BAAA;EACA,+BAAA;ACFN;ADMI;EACE,6BAAA;EACA,gCAAA;ACJN","sourcesContent":["\n.progressTracker {\n  display: flex;\n  flex-flow: row nowrap;\n  margin: 15px auto;\n  .step {\n    flex: 1 0 100px;\n    height: 75px;\n    text-align: center;\n    font-size: 12px;\n    font-weight: bold;\n    color: #8B8B8B;\n    position: relative;\n    display: inline-block;\n    .checkContainer {\n      display: inline-block;\n      height: 25px;\n      font-size: 16px;\n      color: var(--default-color);\n      width: 100%;\n      .fa {\n        visibility: hidden;\n      }\n      .fa.completed {\n        visibility: visible;\n      }\n    }\n    .bar {\n      display: inline-block;\n      background-color: var(--default-color);\n      opacity: .25;\n      height: 6px;\n      width: 100%;\n      margin-top: 6px;\n    }\n    .bar.completion {\n      position: absolute;\n      top: 26px;\n      left: 0px;\n      opacity: 1;\n      z-index: 3;\n      width: 0px;\n    }\n    .stepName {\n      margin: 8px 11px;\n      height: 24px;\n      display: inline-block;\n      line-height: 12px;\n      color: inherit;\n    }\n\n    a.stepName:hover {\n      color: var(--default-color);\n    }\n\n    &.active {\n      color: var(--text-color);\n    }\n    &.completed {\n      color: var(--text-color);\n    }\n  }\n  .step:first-of-type {\n    .bar {\n      border-top-left-radius: 24px;\n      border-bottom-left-radius: 24px;\n    }\n  }\n  .step:last-of-type {\n    .bar {\n      border-top-right-radius: 24px;\n      border-bottom-right-radius: 24px;\n    }\n  }\n}\n",".progressTracker {\n  display: flex;\n  flex-flow: row nowrap;\n  margin: 15px auto;\n}\n.progressTracker .step {\n  flex: 1 0 100px;\n  height: 75px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: bold;\n  color: #8B8B8B;\n  position: relative;\n  display: inline-block;\n}\n.progressTracker .step .checkContainer {\n  display: inline-block;\n  height: 25px;\n  font-size: 16px;\n  color: var(--default-color);\n  width: 100%;\n}\n.progressTracker .step .checkContainer .fa {\n  visibility: hidden;\n}\n.progressTracker .step .checkContainer .fa.completed {\n  visibility: visible;\n}\n.progressTracker .step .bar {\n  display: inline-block;\n  background-color: var(--default-color);\n  opacity: 0.25;\n  height: 6px;\n  width: 100%;\n  margin-top: 6px;\n}\n.progressTracker .step .bar.completion {\n  position: absolute;\n  top: 26px;\n  left: 0px;\n  opacity: 1;\n  z-index: 3;\n  width: 0px;\n}\n.progressTracker .step .stepName {\n  margin: 8px 11px;\n  height: 24px;\n  display: inline-block;\n  line-height: 12px;\n  color: inherit;\n}\n.progressTracker .step a.stepName:hover {\n  color: var(--default-color);\n}\n.progressTracker .step.active {\n  color: var(--text-color);\n}\n.progressTracker .step.completed {\n  color: var(--text-color);\n}\n.progressTracker .step:first-of-type .bar {\n  border-top-left-radius: 24px;\n  border-bottom-left-radius: 24px;\n}\n.progressTracker .step:last-of-type .bar {\n  border-top-right-radius: 24px;\n  border-bottom-right-radius: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
